import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner,
} from "reactstrap";
import { loginAction } from "../../store/actions/authAction";
import logoImg from "../../assets/img/LOVE_MEMENTO.png";

const Login = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState({
        btn: false,
    });
    const [formData, setformData] = useState({ email: "", password: "" });
    const [userNature, setUserNature] = useState(false);
    return (
        <Container>
            <h1 className="text-center pt-5 pb-3">Memento</h1>
            <Row className="justify-content-center">
                <Col lg={6}>
                    <img className="h-75 w-100" src={logoImg} alt="prw" />
                </Col>
                <Col lg={6} md={8} sm={10}>
                    <Card className="py-3  border-0 ">
                        <Form
                            className="mx-3 d-flex flex-column justify-content-center"
                            onSubmit={(e) => {
                                e.preventDefault();
                                setLoader((prev) => ({
                                    ...prev,
                                    btn: true,
                                }));
                                dispatch(
                                    loginAction(formData, () => {
                                        setLoader((prev) => ({
                                            ...prev,
                                            btn: false,
                                        }));
                                    })
                                );
                            }}
                        >
                            <h3 className="text-center py-2">Login</h3>

                            <div className="py-4">
                                <FormGroup className="my-3">
                                    <Label>Email</Label>
                                    <Input
                                        placeholder="Email"
                                        type="email"
                                        required
                                        value={formData.email}
                                        onChange={(e) =>
                                            setformData({
                                                ...formData,
                                                email: e.target.value,
                                            })
                                        }
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label>Password</Label>
                                    <Input
                                        placeholder="Password"
                                        type="password"
                                        required
                                        value={formData.password}
                                        onChange={(e) =>
                                            setformData({
                                                ...formData,
                                                password: e.target.value,
                                            })
                                        }
                                    />
                                </FormGroup>
                                <div className="d-flex justify-content-center">
                                    <Button
                                        className="w-50 mt-4"
                                        color="primary"
                                        type="submit"
                                    >
                                        {loader.btn ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            "Login"
                                        )}
                                    </Button>
                                </div>
                                <p
                                    className="text-center text-primary mt-4 cursor-pointer"
                                    onClick={() => setUserNature(!userNature)}
                                >
                                    {userNature ? "Athelete" : "Fan"} login?
                                </p>
                            </div>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
